var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorksFig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1130.7,
    height: 947.5,
    viewBox: "0 0 1130.7 947.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4163.12,
    y1: 21728.39,
    x2: 4854.61,
    y2: 22268.77,
    gradientTransform: "matrix(1.05, -0.46, -0.4, -0.93, 4621.89, 22911.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#376dbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#009ee9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435,553.7l1.4-22.8a3.4,3.4,0,0,0,2,3.1l-1.3,22.8A3.7,3.7,0,0,1,435,553.7Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M753.7,605.4l-1.4,22.8a2.7,2.7,0,0,1-1.4,2.3l1.3-22.8A3.1,3.1,0,0,0,753.7,605.4Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670.5,665.8l-1.3,22.8a7.5,7.5,0,0,1-5,1.2,9.6,9.6,0,0,1-3.4-1l1.3-22.9a8.5,8.5,0,0,0,3.4,1.1A7.4,7.4,0,0,0,670.5,665.8Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.1,41.6l20.1.4a6.2,6.2,0,0,1,2.9.9L430,42.4A6,6,0,0,0,427.1,41.6Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M842.7,642.9l-20-.4c4.6.1,9.1-5.5,10.6-14.2l20.1.4C851.8,637.4,847.4,643,842.7,642.9Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.6,292.7l20,.4c5.7,3.2,8.7,14.2,6.9,24.8l-20.1-.5C890.3,306.9,887.2,295.8,881.6,292.7Z",
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8-2",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.5,458.9,101,455h.7l.9,2.3a3.1,3.1,0,0,1,.2.8l.3-.7.8-2.4h.7l-1.5,3.9Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.7,569.7c26.2,118.4,221.2,369.7,341.4,377.4s423.6-96.6,471.7-258.6,242.5-158.5,101.5-363C925.4,101,716.2,107.4,648,49.4S371.5-26.7,284.4,57,3.6,136.5.1,292.8C-3.9,468.9,139.5,451.4,165.7,569.7Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "disp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "standbase"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.4,534l-1.3,22.8a3.9,3.9,0,0,1-2.1-2.9l1.4-22.8a3.5,3.5,0,0,0,2,2.9",
    style: {
      fill: "#153852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.4,531.1,435,553.9v-.2l1.4-22.8v.2",
    style: {
      fill: "#13334b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M753.7,605.4l-1.4,22.8a2.7,2.7,0,0,1-1.4,2.3l1.3-22.8a3.1,3.1,0,0,0,1.5-2.3",
    style: {
      fill: "#13334b"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "752.2 607.7 750.9 630.5 669.2 688.6 670.5 665.8 752.2 607.7",
    style: {
      fill: "#122f44"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.1 665.9 660.8 688.8 437.1 556.8 438.4 534 662.1 665.9",
    style: {
      fill: "#163b57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.5,469.3a7.9,7.9,0,0,1,3.4,1l223.7,132c2.5,1.5,2.8,3.9.6,5.4l-81.7,58.1a7.4,7.4,0,0,1-5,1.2,8.5,8.5,0,0,1-3.4-1.1L438.4,534c-2.5-1.5-2.7-3.9-.6-5.4l81.7-58.2A8,8,0,0,1,524.5,469.3Z",
    style: {
      fill: "#19405e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670.5,665.8l-1.3,22.8a7.6,7.6,0,0,1-4.6,1.2l1.3-22.8a7.4,7.4,0,0,0,4.6-1.2",
    style: {
      fill: "#13334b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.9,667l-1.3,22.8h-.4a8.3,8.3,0,0,1-3.4-1l1.3-22.8a10.2,10.2,0,0,0,3.4,1h.4",
    style: {
      fill: "#153852"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "stand"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "671.1 503.2 668.9 624.9 517.1 544.2 519.2 422.5 671.1 503.2",
    style: {
      fill: "#173c57"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.1 503.2 685.9 499.6 683.7 621.3 668.9 624.9 671.1 503.2",
    style: {
      fill: "#14344c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.2 422.5 534 418.9 685.9 499.6 671.1 503.2 519.2 422.5",
    style: {
      fill: "#173e5a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "dispaly"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.1,41.6l20.1.4a7.7,7.7,0,0,1,2.6.7l-20.1-.5a5.8,5.8,0,0,0-2.6-.6",
    style: {
      fill: "#13334b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.7,42.2l20.1.5.3.2L430,42.4l-.3-.2",
    style: {
      fill: "#14364f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.3,628.3l20.1.4c-1.6,8.7-6,14.4-10.7,14.3l-20.1-.5c4.7.1,9.2-5.5,10.7-14.2",
    style: {
      fill: "#123147"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "430 42.4 450.1 42.9 901.6 293.1 881.6 292.7 430 42.4",
    style: {
      fill: "#14354d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "888.4 317.4 908.5 317.9 853.4 628.7 833.3 628.3 888.4 317.4",
    style: {
      fill: "#133148"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.6,292.7c5.6,3.1,8.7,14.2,6.8,24.7L833.3,628.3c-1.9,10.5-7.9,16.5-13.6,13.4L368.2,391.4c-5.7-3.2-8.7-14.2-6.8-24.8l55-310.8c1.9-10.5,8-16.5,13.6-13.4Z",
    style: {
      fill: "#194362"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.6,292.7l20,.4c2.8,1.6,5,5.1,6.2,9.5l-20-.5c-1.3-4.4-3.5-7.9-6.2-9.4",
    style: {
      fill: "#14364f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.8,302.1l20,.5a31.5,31.5,0,0,1,1.2,8.7l-20.1-.5a37,37,0,0,0-1.1-8.7",
    style: {
      fill: "#13334b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.9,310.8l20.1.5a48.9,48.9,0,0,1-.5,6.6l-20.1-.5a29.4,29.4,0,0,0,.5-6.6",
    style: {
      fill: "#123147"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "dis"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT",
    "data-name": "DISPALY CONTENT",
    d: "M806.2,610.5,384.6,372.7a8,8,0,0,1-4-8.2L428.9,75.9a8,8,0,0,1,9.2-6.5,7.5,7.5,0,0,1,2.5.9L862.3,308a8.2,8.2,0,0,1,3.9,8.3L818,604.9a8.1,8.1,0,0,1-9.2,6.5A11.4,11.4,0,0,1,806.2,610.5Z",
    style: {
      fill: "#dcf0ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "disp_contetn",
    "data-name": "disp contetn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-2",
    "data-name": "DISPALY CONTENT-2",
    d: "M764.7,586.6,418.2,391.2a6,6,0,0,1-2.9-6.3l50.6-262.5a5.9,5.9,0,0,1,7-4.7,6.4,6.4,0,0,1,1.8.6L821.2,313.7a5.9,5.9,0,0,1,2.9,6.4L773.6,582.5a6,6,0,0,1-7,4.8Z",
    style: {
      fill: "#71a0bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-3",
    "data-name": "DISPALY CONTENT-3",
    d: "M606.7,488.7,443.9,396.9a5.9,5.9,0,0,1-2.9-6.3l34.9-190.7a6,6,0,0,1,7-4.8l1.8.7,162.8,91.8a6,6,0,0,1,3,6.3l-35,190.7a5.9,5.9,0,0,1-6.9,4.8A4.4,4.4,0,0,1,606.7,488.7Z",
    style: {
      fill: "#3a6689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-4",
    "data-name": "DISPALY CONTENT-4",
    d: "M745.1,566.8,636.7,505.7a5.8,5.8,0,0,1-3-6.2l34.9-190.8a5.9,5.9,0,0,1,6.9-4.8,4.8,4.8,0,0,1,1.8.6l108.4,61.2a5.8,5.8,0,0,1,3,6.2L753.8,562.7a5.9,5.9,0,0,1-6.9,4.8A3.6,3.6,0,0,1,745.1,566.8Z",
    style: {
      fill: "#3a6689"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-5",
    "data-name": "DISPALY CONTENT-5",
    d: "M811.6,356.1,462.7,158.6a4,4,0,0,1-1.9-4.2l6.3-34.7a4.2,4.2,0,0,1,4.7-3.2l1.2.5L821.9,314.5a4,4,0,0,1,2,4.2l-6.4,34.7a4,4,0,0,1-4.6,3.2Z",
    style: {
      fill: "#1a6691"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-6",
    "data-name": "DISPALY CONTENT-6",
    d: "M588.3,450.1,467,381.8a6.2,6.2,0,0,1-2.9-6.5l11.6-54.5a6,6,0,0,1,7.1-4.7l1.7.7,121.2,68.3a5.9,5.9,0,0,1,2.9,6.5l-11.5,54.6a6.1,6.1,0,0,1-7.1,4.6Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-7",
    "data-name": "DISPALY CONTENT-7",
    d: "M728.8,542.2l-77.4-43.6a5.9,5.9,0,0,1-2.9-6.5l11.1-52.4a5.9,5.9,0,0,1,7.1-4.6,4.9,4.9,0,0,1,1.7.6l77.4,43.7a5.8,5.8,0,0,1,2.9,6.4l-11.1,52.5a6.1,6.1,0,0,1-7.1,4.6Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-8",
    "data-name": "DISPALY CONTENT-8",
    d: "M615.9,309.3,494.4,240.8a6,6,0,0,1-2.9-6.4h0a5.8,5.8,0,0,1,7-4.3,4.4,4.4,0,0,1,1.6.6l121.5,68.5a5.6,5.6,0,0,1,2.8,6.3h0a5.7,5.7,0,0,1-6.9,4.4A4.4,4.4,0,0,1,615.9,309.3Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-9",
    "data-name": "DISPALY CONTENT-9",
    d: "M621.2,332h0a6,6,0,0,1-7,4.4l-1.6-.6L491.1,267.3a5.8,5.8,0,0,1-2.8-6.4h0a5.8,5.8,0,0,1,6.9-4.4,4.4,4.4,0,0,1,1.6.6l121.6,68.5A6.1,6.1,0,0,1,621.2,332Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-10",
    "data-name": "DISPALY CONTENT-10",
    d: "M617,358.7h0a5.7,5.7,0,0,1-7,4.3,4.7,4.7,0,0,1-1.5-.6L486.9,293.9a5.8,5.8,0,0,1-2.8-6.4h0a5.8,5.8,0,0,1,7-4.3,5.2,5.2,0,0,1,1.6.6l121.5,68.5A5.8,5.8,0,0,1,617,358.7Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-11",
    "data-name": "DISPALY CONTENT-11",
    d: "M759.5,387.7l-78.6-44.4a5.5,5.5,0,0,1-2.6-5.6h0a5.3,5.3,0,0,1,6.3-4.2,5.2,5.2,0,0,1,1.6.6l78.5,44.3a5.4,5.4,0,0,1,2.7,5.7h0a5.4,5.4,0,0,1-6.3,4.1Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-12",
    "data-name": "DISPALY CONTENT-12",
    d: "M755.3,413.6l-78.6-44.3a5.5,5.5,0,0,1-2.6-5.6h0a5.3,5.3,0,0,1,6.3-4.2,5.2,5.2,0,0,1,1.6.6l78.5,44.3a5.2,5.2,0,0,1,2.6,5.6h0a5.3,5.3,0,0,1-7.8,3.6Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-13",
    "data-name": "DISPALY CONTENT-13",
    d: "M750.3,439.1l-78.6-44.3a5.2,5.2,0,0,1-2.6-5.6h0a5.2,5.2,0,0,1,6.2-4.2,4.4,4.4,0,0,1,1.6.6l78.6,44.3a5.3,5.3,0,0,1,2.6,5.6h0a5.3,5.3,0,0,1-6.2,4.2A4.4,4.4,0,0,1,750.3,439.1Z",
    style: {
      fill: "#1b435e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-14",
    "data-name": "DISPALY CONTENT-14",
    d: "M745.9,464.2l-78.6-44.3a5.4,5.4,0,0,1-2.6-5.7h0a5.3,5.3,0,0,1,6.2-4.1l1.6.5L751.1,455a5.2,5.2,0,0,1,2.6,5.6h0a5.2,5.2,0,0,1-6.2,4.2A4.4,4.4,0,0,1,745.9,464.2Z",
    style: {
      fill: "#1b435e"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ledder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.8,305.5h0a6,6,0,0,1,4.1,7.2L312.5,599.9a5.9,5.9,0,0,1-7.2,4.1h0a5.9,5.9,0,0,1-4.1-7.2l77.4-287.1A5.8,5.8,0,0,1,385.8,305.5Z",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.3,
    y: 358.3,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-114.4 636.4) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.5,
    y: 412.4,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-176.7 655) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 464.8,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-233.8 677.6) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.6,
    y: 520.8,
    width: 11.7,
    height: 84.72,
    rx: 4.5,
    transform: "translate(-296.4 699.4) rotate(-69.5)",
    style: {
      fill: "#6e8ea0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_right",
    "data-name": "shoe right",
    d: "M374.1,584.4c7.5-1.5,10.9-4.1,16.9-3.4s7-6,10.2-8.1c5.2-3.5,12.2-6.1,15.2-9.7,6.2-7.4,3-12.9-2.1-11.6-13.7,3.3-13.5,6.8-17.7,5.6-1.2-.3-3.3,5.9-5.3,6.1a152.6,152.6,0,0,0-20.7,4.2Z",
    style: {
      fill: "#0c2030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "shoe_left",
    "data-name": "shoe left",
    d: "M339.4,539.2c-1.9,1.5-3.8,7.6-4.2,10.1-1.3,6.7-1,11.4.8,11.4s10.4-2.2,16.7-8.8,10.4-8.4,13.3-15.7c11.5-29.4,5.1-25.4-7.7-12.9Z",
    style: {
      fill: "#0c2030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "pants",
    d: "M370.6,560.9a7.5,7.5,0,0,0,4.3,7,14.3,14.3,0,0,0,7,1.5c5.8,0,13.5,0,15.4-1.9s1.9-28.8,1.9-38.4,3.8-28.8,3.8-36.5,5.8-34.5,7.7-48,1.9-34.5,1.9-53.7-57.6-32.6-59.5-23-7.7,15.3-3.8,44.1c1,7.6,0,19.2,0,28.8s-1.9,13.4-3.9,19.2-3.8,17.3-5.7,28.8-1.9,26.9-1.9,34.5-3.9,19.2,3.8,19.2c0,0,7.7,0,11.5-1.9s7.7-19.2,7.7-19.2c0-23,3.8-42.2,3.8-44.2s5.8-26.8,7.7-30.7,3.9-5.7,3.9,21.2-3.9,28.7-3.9,46C372.3,527.1,371.2,550.9,370.6,560.9Z",
    style: {
      fill: "#325e93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "wihiteshirt",
    d: "M429.9,256.5c0,5.8,1.9,11.5,0,19.2s-32.6-13.4-32.6-13.4l-5.8-13.5,1.9-3.8,11.5-1.9c2,0,3.9,5.8,7.7,7.7s5.8,5.7,9.6,5.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.1,293.1c-1.1,2.5-2.1,4.6-2.6,5.6-1.9,3.7-3.7,7.4-12.4,16.3l-1,1s-5.8,7.7-3.9-5.8,3.2-17.2,7.8-23.9l3.9,2.2c0,.7-.1,1.4-.1,2.1,0,2.6.9,1.5,2.5-.8s4.6-7.3,7.7-9.4S492.9,286.6,490.1,293.1Z",
    style: {
      fill: "#b7ceea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.9,319.9c1.4-1.7,2.7-3.1,3.8-4.3l-10.7,40-2.7,2.7c-11.5,11.5-21.1,13.4-21.1,13.4a8.7,8.7,0,0,0-2.8-.1,7,7,0,0,0-2,.8c-1.5,1-2.8,3-2.8,6.9,0,9.7,1.9,21.2,0,28.8-.2.6-.9.8-2,.9-2.8.1-8-.9-13.4-.9-7.7,0-21.1-3.8-26.9-7.6s-17-16.8-21.9-23.4l-1.1-1.6c-3.8-5.7,1.9-21.1,5.8-28.8s9.5-13.4,11.5-23c0,0-2-40.3,0-53.8s5.7-24.9,13.4-28.7,11.5-3.9,23,0c2.4.7,3.8,2.2,4,3.5h0c.2,1.8-2.1,3.3-7.8,2.2-1.9-.4-3.8,1.9-3.8,5.8s5.7,9.6,9.6,13.4,9.6,5.8,15.3,5.8c3.9,0,7.7-3.5,10.4-5.2s2.4-1.2,3-.6,7.7,13.4,7.7,17.3v28.8c0,9.5-1.9,21.1-1.9,23S447.7,326,452.9,319.9Z",
    style: {
      fill: "#5ba2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,317.9c0,2-3.9,5.8-3.9,5.8l-8.4,11.1,4.9-18.3a5.8,5.8,0,0,0-4.1-7.1h-.2c2.5-1.1,4-.1,5.9.9a11.1,11.1,0,0,1,4.9,4.7A7.5,7.5,0,0,1,476,317.9Z",
    style: {
      fill: "#5ba2ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    d: "M449.1,222c1.9-5.8,5.8-7.7,3.8-11.5s1.9-3.9-5.7-7.7-11.5-5.8-17.3-5.8-15.4,0-19.2,3.9-5.8,13.4-5.8,21.1,2,19.2,3.9,26.8,30.7-3.8,32.6-9.6S449.1,222,449.1,222Z",
    style: {
      fill: "#264860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "head",
    d: "M451,216.2c0,5.8,1.9,7.7,0,17.3s-5.7,13.4-7.7,17.3-11.5,0-11.5,3.8-1.9,5.8-1.9,5.8a8.4,8.4,0,0,1-5.8,1.9s-1.9,0-5.7-1.9-5.8-1.9-7.7-3.9-3.8-1.9-5.8-5.7c-.3-.8,2.7-3.3,3.9-3.9,3.8-1.9,3.8-1.9,5.7,0s1.9,1.9,5.6.1a4.3,4.3,0,0,0,2.1-5.8h0c-1.9-3.8-1.9-7.6,1.9-7.6s3.9,3.8,3.9,5.7,1.9,2,3.8-5.7,3.9-11.5,5.8-13.5,1.9-3.8,5.7-3.8Z",
    style: {
      fill: "#b7ceea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,302.6c-3.8,13.4-5.7,23-5.7,30.7s-2,24.9,1.9,30.7a26.5,26.5,0,0,0,8.6,8.4l4.8-.7s-9.6,1.9-9.6-11.5,1.9-26.9,1.9-34.6S412.6,302.6,412.6,302.6Z",
    style: {
      fill: "#5e8faa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "note"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532,241.1l-12.4,42.5a3.9,3.9,0,0,1-1.9,2.1l-17,6.9-5.1,2.1h-.3a3.6,3.6,0,0,1-2.7-.2l-2.5-1.4-5.8-3.3-2.4-1.3c.6-5.4,2.6-10.9-2.5-4.1a13.3,13.3,0,0,0-1.4,1.9l-29.1-16.5c-.5-.2-.6-.8-.4-1.6l18.2-62.5c.4-1.2,1.5-2,2.2-1.6l62.7,35.3A1.4,1.4,0,0,1,532,241.1Z",
    style: {
      fill: "#3b79bc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-15",
    "data-name": "DISPALY CONTENT-15",
    d: "M495.6,294.7c-.9.3-1.4-.1-1.1-1l5.1-17.7c.3-.8,1.6-1,2.7-.4l15.3,8.6c.9.5.8,1.2,0,1.5Z",
    style: {
      fill: "#376c9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-16",
    "data-name": "DISPALY CONTENT-16",
    d: "M515.4,246.5l-42.9-24.2a2.2,2.2,0,0,1-1.1-2.7h0a2.3,2.3,0,0,1,2.9-1.4l.4.2,42.9,24.2a2.1,2.1,0,0,1,1.1,2.7h0a2.3,2.3,0,0,1-2.9,1.4Z",
    style: {
      fill: "#2b517f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-17",
    "data-name": "DISPALY CONTENT-17",
    d: "M503.1,252.4l-34.9-19.7a2,2,0,0,1-.7-2.5h0a2.1,2.1,0,0,1,2.9-1.4l34.9,19.7a2,2,0,0,1,.7,2.5h0A2.1,2.1,0,0,1,503.1,252.4Z",
    style: {
      fill: "#2b517f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-18",
    "data-name": "DISPALY CONTENT-18",
    d: "M483.8,268.8l-23.5-13.3c-.5-.3-.6-1.2-.2-2.2h0c.6-1.2,1.8-2.1,2.4-1.7L486,264.8c.6.3.7,1.3.2,2.2h0C485.7,268.3,484.5,269.2,483.8,268.8Z",
    style: {
      fill: "#2b517f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "DISPALY_CONTENT-19",
    "data-name": "DISPALY CONTENT-19",
    d: "M507.7,268.6l-42.9-24.2a2.4,2.4,0,0,1-1.1-2.8h0a2.4,2.4,0,0,1,2.9-1.4l.4.2,42.9,24.2a2.2,2.2,0,0,1,1.1,2.7h0a2.3,2.3,0,0,1-2.9,1.5Z",
    style: {
      fill: "#2b517f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446,355.6c6.3-6.7,12.6-14.3,17.7-20.8L404.4,554.9l-5.5,20.3-17.3,64.4a5.9,5.9,0,0,1-7.2,4.1,5.8,5.8,0,0,1-4.1-7.2l14.8-55.2,3.3-12,1.5-5.8,9.3-34.3Z",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.7,315.6l.6-2.1a5.8,5.8,0,0,1,5.7-4.3,3,3,0,0,1,1.3.2C462.5,310.1,460.2,311.9,456.7,315.6Z",
    style: {
      fill: "#6e8ea0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "finger",
    d: "M481.9,288.5l-3.9-2.2,1.4-1.8C484.5,277.7,482.5,283.2,481.9,288.5Z",
    style: {
      fill: "#b7ceea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "slave",
    d: "M468.6,316.5l-4.9,18.3c-5.1,6.5-11.4,14.1-17.7,20.7l10.7-39.9c3.5-3.7,5.8-5.5,7.6-6.3h.2A6,6,0,0,1,468.6,316.5Z",
    style: {
      fill: "#5ba2ce"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksFig);
export default __webpack_public_path__ + "static/media/works_fig.438ac2659d2a0767bff1b77ccb4e86e5.svg";
export { ForwardRef as ReactComponent };